class Subscribe {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.ui.$email.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.ui.$form.removeEventListener('focusin', () => this.ui.$emailLabel.style.opacity = '0');
    this.ui.$form.removeEventListener('focusout', () => this.ui.$emailLabel.style.opacity = '1');
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$form = this.element.querySelector('.fsForm');
    this.ui.$email = this.ui.$form.querySelector('[fs-field-type="email"]');
    this.ui.$emailInput = this.ui.$form.querySelector('.fsFormatEmail');
    this.ui.$emailLabel = this.ui.$form.querySelector('.fsLabel');
  }

  bindEvents() {
    this.ui.$email.addEventListener('keyup', this.onKeyUp.bind(this));
    this.ui.$form.addEventListener('focusin', () => this.ui.$emailLabel.style.opacity = '0');
    this.ui.$form.addEventListener('focusout', () => this.ui.$emailLabel.style.opacity = '1');
  }

  onKeyUp(e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode == 13) {
      this.ui.$form.submit();
    }
  }
}

export default Subscribe;
